module.exports = __webpack_public_path__ + "static/media/ic_audit.6363daab.svg";